import { useCityList } from "@/component/GoldSilver/CITY_CONSTANT";
import { getCitiesForLocation } from "@/component/GoldSilver/cityList";
export default function CityLinksPanel({ city: currentCity, isGold = true, colors = {} }) {
  const allCities = useCityList();
  const cities = currentCity ? getCitiesForLocation(currentCity) : allCities;
  return (
    <div className="border border-zinc-300 rounded-lg grid grid-cols-1 md:grid-cols-2">
      {cities?.filter((c) => !c.city.includes(currentCity)).map((city, index) => (
        <a
          key={index}
          href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/${isGold ? "gold-rates" : "silver-rates"}/${city?.city_url}-${isGold ? "gold" : "silver"}-price-today`}
          className={`inline-flex gap-x-1.5 items-center ${index<cities.length-1 ? "border-b" : ""} ${index%2 === 0 ? "border-r" : ""} text-sm font-semibold px-3 py-2.5 hover:text-primary`}
        >
          <span className={`rounded-full w-2 h-2 ${colors.gradient}`}></span>
          {city?.city_hn} {isGold ? "में सोने का भाव" : "में चांदी का भाव"}
        </a>
      ))}
    </div>
  );
}
